module.exports = __webpack_public_path__ + "static/media/muli-latin-400.8160dac0.woff2";